/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailItemInvoice_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly " $refType": "PdpSharedDetailItemInvoice_user";
};
export type PdpSharedDetailItemInvoice_user$data = PdpSharedDetailItemInvoice_user;
export type PdpSharedDetailItemInvoice_user$key = {
    readonly " $data"?: PdpSharedDetailItemInvoice_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailItemInvoice_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailItemInvoice_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '93dd0139e24f5d53c02ad4ca197e0255';
export default node;
